/** Broche isométrico do mapa — atalho do chrome para `/roadmap`. */
export const ROADMAP_MAP_ICON_SRC = '/website/nav/roadmap-map.png';

/** Broche isométrico de "O Jogo" — mesmo cidadão do hero portal, atalho do chrome para `/o-jogo`. */
export const GAME_NAV_ICON_SRC = '/website/nav/game-badge.png';
